import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'

@ObjectType()
@InputType('PaymentBalanceInput')
export class PaymentBalance {
  @Field(() => ID)
  _id: string

  @Field(() => Float)
  balance: number

  @Field(() => Float)
  totalPaid: number
}
